// extracted by mini-css-extract-plugin
module.exports =  {"hasSpecLevel":"hasSpecLevel__lReyb","layerModel":"layerModel__Q27iJ","specSelect":"specSelect__3YRYk","selectedValueSelect":"selectedValueSelect__MoMLu"};